import type { ComponentProps } from "react";
import { t } from "ttag";

import { Button, Dialog, HeartBrokenIcon } from "@/shared/ui";

export const CancellationEmailSentModal = ({
  open,
  onOpenChange,
}: ComponentProps<typeof Dialog.Root>) => {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Content>
        <Dialog.Header icon={HeartBrokenIcon}>
          <Dialog.Title>{t`Cancellation request received`}</Dialog.Title>
          <Dialog.Description>
            {t`We understand that you want to cancel your LevelsRx subscription, someone from our team will be calling you to process your cancellation.`}
          </Dialog.Description>
        </Dialog.Header>

        <Dialog.Footer>
          <Button size="lg" onClick={() => onOpenChange?.(false)}>
            {t`Close`}
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
};
